<template>
  <div>
    <v-btn @click="createCompaign()" small color="primary" dark>
      <!-- <v-icon left>fas fa-registered</v-icon> -->
      Create Add
    </v-btn>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <div>
        <v-card class="mx-auto my-5" max-width="900">
          <v-card>
            <v-card-title>
              <span class="headline">Compaign</span>
              <v-spacer></v-spacer>
              <v-btn color="secondary" text @click="close()">
                <v-icon>
                  fas fa-times-circle
                </v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-row justify="center">
                <v-col cols="12" sm="10">
                  <v-card-text>
                    <v-text-field
                      v-model="Compaign.Name"
                      label="Compaign Name"
                      dense
                      solo
                    ></v-text-field>
                    <v-textarea
                      v-model="Compaign.Description"
                      filled
                      label="description"
                      dense
                      solo
                    ></v-textarea>
                    <v-select
                      v-model="Compaign.State"
                      :items="states"
                      label="Select State"
                      solo
                    >
                      <template slot="selection" slot-scope="data">
                        <!-- HTML that describe how select should render selected items -->
                        {{ data.item.name }}
                      </template>
                     <template slot="item" slot-scope="data">
                        <!-- HTML that describe how select should render
                        items when the select is open -->
                        {{ data.item.name }}
                      </template>
                    </v-select>
                    <v-text-field v-model="Compaign.City" label="City" dense solo></v-text-field>
                    <v-flex xs12 sm12 md12>
                      <v-row>
                        <v-col>
                          <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :return-value.sync="Compaign.startDate"
                            transition="scale-transition"
                            offset-y
                            min-width="270px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="startDate"
                                label="Start Date"
                                prepend-icon="fas fa-calendar-alt"
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="startDate" no-title scrollable>
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="menu = false">
                                Cancel
                              </v-btn>
                              <v-btn text color="primary" @click="$refs.menu.save(startDate)">
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col>
                          <v-menu
                            ref="menu2"
                            v-model="menu2"
                            :close-on-content-click="false"
                            :return-value.sync="Compaign.endDate"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="endDate"
                                label="End Date"
                                prepend-icon="fas fa-calendar-alt"
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="endDate" no-title scrollable>
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="menu2 = false">
                                Cancel
                              </v-btn>
                              <v-btn text color="primary" @click="$refs.menu2.save(endDate)">
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                    </v-flex>
                    <div>
                      <v-btn @click="onPickFile">
                        <v-icon color="primary" left>fas fa-file-image</v-icon>
                        UpLoad Image
                      </v-btn>
                      <label class="file-label">
                        <input
                          class="file-input"
                          type="file"
                          style="display: none"
                          ref="fileInput"
                          name="resume"
                          @change="onFilePick($event)"
                        />
                      </label>
                      <figure v-if="imageURL" class="image is-100x100">
                        <v-img :src="imageURL" class="is-rounded"></v-img>
                      </figure>
                    </div>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="secondary" @click="close()">Close</v-btn>
                    <v-btn color="primary" text @click="submit" :disabled="Compaign.Name === ''"
                      >Update</v-btn
                    >
                  </v-card-actions>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-card>
      </div>
    </v-dialog>
  </div>
</template>
<script>
import { Vue, Component } from 'vue-property-decorator';
import CompaignAdd from '@/model/CompaignAdd';
import Post from '@/model/Post';
import User from '@/model/User';
import { COLLECTION_CAMPAIGNADDS, COLLECTION_USERS } from '@/model/AppConstants';
import Criteria from '@/model/Criteria';
import FirebaseUtil from '@/model/FirebaseUtil';
import AccessType from '@/model/AccessType';
import StateType from '@/model/typelist/StateType';
@Component({
  components: {},
})
export default class CampaignAddComponent extends Vue {
  dialog = false;
  db = null;
  storage = null;
  menu = false;
  menu2 = false;
  endDate = new Date().toISOString().substr(0, 10);
  startDate = new Date().toISOString().substr(0, 10);
  file = {};
  imageURL = '';
  items = [1, 2, 3, 4, 5];
  // eslint-disable-next-line
  get states() {
    return StateType.allStates();
  }
  // positionItems= ['top', 'left', 'right', 'bottom'];
  // mounted() {
  //   if (this.$store.state.firebase) {
  //     this.db = this.$store.state.firebase.firestore();
  //     this.storage = this.$store.state.firebase.storage().ref();
  //   }
  // }
  defaultCompaign = {
    Name: '',
    Description: '',
    startDate: '',
    endDate: '',
    Priority: '',
    State: '',
    City: '',
    imageURL: '',
  // date= new Date().toISOString().substr(0, 10);
  };
  createCompaign() {
    this.dialog = true;
  }
  close() {
    this.dialog = false;
    this.cleanCamp();
  }
  // $refs!:{
  //     fileInput: HTMLFormElement;
  // }
  onPickFile() {
    this.$refs.fileInput.click();
  }
  onFilePick(event) {
    [this.file] = event.target.files;
    const fr = new FileReader();
    fr.onload = () => {
      this.imageURL = fr.result;
    };
    fr.readAsDataURL(this.file);
  }
  Compaign = { ...{}, ...this.defaultCompaign };
  get parsedCompaign() {
    const postObj = new Post(this.Compaign.Name,
      FirebaseUtil.ObjectToRef(COLLECTION_USERS, this.$store.state.currentUser.uid));
    postObj.content = this.Compaign.Description;
    postObj.access = { ...AccessType.campaignAddType };
    const criteriaObj = new Criteria(
      { ...this.Compaign.State },
      this.Compaign.City,
      this.Compaign.endDate,
      this.Compaign.startDate,
    );
    const campaignAdd = new CompaignAdd(postObj, criteriaObj);
    campaignAdd.post = { ...postObj };
    campaignAdd.criteria = { ...criteriaObj };
    return campaignAdd;
  }
  submit() {
    this.$store.dispatch('addToCampaignAdd', {
      collection: COLLECTION_CAMPAIGNADDS,
      payload: { ...this.parsedCompaign },
      file: this.file,
    });
    this.dialog = false;
    this.cleanCamp();
  }
  cleanCamp() {
    this.Compaign.Name = '';
    this.Compaign.Description = '';
    this.Compaign.State = '';
    this.Compaign.City = '';
    this.Compaign.startDate = '';
    this.Compaign.endDate = '';
    this.imageURL = '';
    this.file = {};
  }
}
</script>
<style scoped>
.textFieldLabel {
  font-size: 18px;
}
</style>